export default __webpack_public_path__ + "static/media/comparativa.b4d49f0d.png";